import { ThemeOptions } from '@material-ui/core';

const themeBase: ThemeOptions = {
  typography: {
    fontFamily: "'Rubik', sans-serif",
    h1: { fontFamily: "'Averia Serif Libre', serif" },
    h2: { fontFamily: "'Averia Serif Libre', serif" },
    h3: { fontFamily: "'Averia Serif Libre', serif" },
    h4: { fontFamily: "'Averia Serif Libre', serif" },
    h5: { fontFamily: "'Averia Serif Libre', serif" },
    h6: { fontFamily: "'Averia Serif Libre', serif" },
  },
};

export default themeBase;
